import * as THREE from "three";

export const ORIGIN = new THREE.Vector3(0, 0, 0);

export const VIEW_DIRECTIONS = {
  iso: new THREE.Vector3(1, 0.85, 1),
  front: new THREE.Vector3(0, 0, 1),
  back: new THREE.Vector3(0, 0, -1),
  left: new THREE.Vector3(-1, 0, 0),
  right: new THREE.Vector3(1, 0, 0),
  top: new THREE.Vector3(0, 1, 0),
};

export function centerObjectAtOrigin(object) {
  const box = new THREE.Box3().setFromObject(object);
  const center = box.getCenter(new THREE.Vector3());
  object.position.sub(center);
  object.updateMatrixWorld(true);
}

export function fitDistanceForObject(object, camera, padding = 1.3) {
  const sphere = new THREE.Box3().setFromObject(object).getBoundingSphere(new THREE.Sphere());
  const radius = Math.max(sphere.radius, 0.001);
  const aspect = Math.max(camera.aspect || 1, 0.01);
  const vFov = (camera.fov * Math.PI) / 180;
  const hFov = 2 * Math.atan(Math.tan(vFov / 2) * aspect);
  const distV = radius / Math.sin(vFov / 2);
  const distH = radius / Math.sin(hFov / 2);
  return Math.max(distV, distH) * padding;
}

export function applyCameraView(camera, controls, object, preset, fitDistance) {
  const distance = fitDistance || fitDistanceForObject(object, camera);
  const dir = (VIEW_DIRECTIONS[preset] || VIEW_DIRECTIONS.iso).clone().normalize();

  controls.target.copy(ORIGIN);
  camera.position.copy(dir.multiplyScalar(distance));

  if (preset === "top") {
    camera.up.set(0, 0, -1);
  } else {
    camera.up.set(0, 1, 0);
  }

  const size = new THREE.Box3().setFromObject(object).getSize(new THREE.Vector3());
  const maxDim = Math.max(size.x, size.y, size.z, 0.001);
  camera.near = Math.max(maxDim / 1000, 0.01);
  camera.far = Math.max(distance * 10, maxDim * 20);
  camera.updateProjectionMatrix();
  camera.lookAt(ORIGIN);
  controls.update();
}

export function createPreviewLights(scene) {
  scene.add(new THREE.AmbientLight(0xffffff, 0.65));
  const keyLight = new THREE.DirectionalLight(0xffffff, 0.95);
  keyLight.position.set(3, 5, 4);
  scene.add(keyLight);
  const fillLight = new THREE.DirectionalLight(0x7dd3fc, 0.35);
  fillLight.position.set(-4, 1, -2);
  scene.add(fillLight);
}

export function configurePreviewRenderer(renderer) {
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.1;

  const canvas = renderer.domElement;
  canvas.style.display = "block";
  canvas.style.width = "100%";
  canvas.style.height = "100%";
}
